import Block from '../../../../_base/src/components/block/index'

export default class DeepdaleNav extends Block {
	static title = 'nav'

	constructor($el) {
		super($el)

		let ticking = false

		if (this.$el.hasModifier('large')) {
			$(window).on('scroll', () => {
				if (!ticking) {
					window.requestAnimationFrame(() => {
						const rect = $('.page-header').get(0).getBoundingClientRect()

						if (rect.bottom < 0) {
							this.$el.removeModifier('large')
						} else {
							this.$el.addModifier('large')
						}

						ticking = false
					})

					ticking = true
				}
			})
		}
	}
}
